import Swal from "sweetalert2";

export const CustomAlert = (msg: string) =>
  Swal.fire({
    title: "Error",
    text: msg,
    icon: "error",
    confirmButtonText: "Confirm",
    background: "#0E1225",
    color: "#FFFFFF",
  });
